let context = require.context('./', false, /-extractor\.js$/);
export default context.keys().sort().map(context).map((m) => m.default);